import React from "react";
import { Formik } from "formik";
import { TextField, Paper, FormControl, InputLabel, Input, InputAdornment, IconButton, withStyles, Button, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import clsx from 'clsx';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(0)
    },

    formControl: {
        width: "100%",
        marginBottom: theme.spacing(1)
    },
    textField: {
        marginBottom: theme.spacing(1)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    }
});

const UserForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;
    const [value, setValue] = React.useState(false);

    const handleClickShowPassword = () => {
        setValue(!value);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Paper className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                label={translations['name'] || 'Name'}
                                placeholder={translations['name'] || 'Name'}
                                name="FirstName"
                                fullWidth={true}
                                value={values.FirstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.FirstName && touched.FirstName)}
                                margin={"dense"}
                            />
                            <TextField
                                label={translations['last_name'] || 'Last name'}
                                placeholder={translations['last_name'] || 'Last name'}
                                name="LastName"
                                fullWidth={true}
                                value={values.LastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LastName && touched.LastName)}
                                margin={"dense"}
                            />
                            <TextField
                                label={translations['username'] || 'Username'}
                                placeholder={translations['username'] || 'Username'}
                                name="Username"
                                fullWidth={true}
                                value={values.Username}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={true}
                                error={!!(errors.Username && touched.Username)}
                                margin={"dense"}
                            />
                            <TextField
                                label={translations['e_mail'] || 'E-Mail'}
                                placeholder={translations['e_mail'] || 'E-Mail'}
                                name="Email"
                                fullWidth={true}
                                value={values.Email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Email && touched.Email)}
                                margin={"dense"}
                                type="email"
                            />
                            <TextField
                                label={translations['phone_number'] || 'Phone number'}
                                placeholder={translations['phone_number'] || 'Phone number'}
                                name="PhoneNumber"
                                fullWidth={true}
                                value={values.PhoneNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.textField}
                                error={!!(errors.PhoneNumber && touched.PhoneNumber)}
                                margin={"dense"}
                            />
                            <FormControl className={clsx(classes.margin, classes.formControl)}>
                                <InputLabel htmlFor="in-category-1">{translations['password'] || 'Password'}</InputLabel>
                                <Input
                                    id="in-category-1"
                                    type={value ? 'text' : 'password'}
                                    name="Password"
                                    value={values.Password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Password && touched.Password)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}>
                                                {value ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <FormControl className={clsx(classes.margin, classes.formControl)}>
                                <InputLabel htmlFor="in-category-2">{translations['password_repeat'] || 'Password repeat'}</InputLabel>
                                <Input
                                    id="in-category-2"
                                    type={value ? 'text' : 'password'}
                                    value={values.RepeatPassword}
                                    onChange={handleChange}
                                    name="RepeatPassword"
                                    onBlur={handleBlur}
                                    error={!!(errors.RepeatPassword && touched.RepeatPassword)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {value ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>


                    );
                }}
            </Formik>
        </Paper >
    );
};
export default withStyles(styles, { withTheme: true })(UserForm);
